// @flow

/**
 * The type of (redux) action to add the donorbox url.
 *
 * {
 *     type: ADD_DONORBOX_URL,
 *     token: string
 * }.
 */
export const ADD_CANDP_URL = 'ADD_CANDP_URL';

/**
 * The type of (redux) action to receive the donorbox url.
 *
 * {
 *     type: RECEIVE_DONORBOX_URL,
 *     token: string
 * }.
 */
export const RECEIVE_CANDP_URL = 'RECEIVE_CANDP_URL';

/**
 * The type of (redux) action to remove the donorbox url.
 *
 * {
 *     type: REMOVE_DONORBOX_URL,
 *     token: string
 * }.
 */
export const REMOVE_CANDP_URL = 'REMOVE_CANDP_URL';

/**
 * The type of (redux) action to remove the donorbox url.
 *
 * {
 *     type: REMOVE_DONORBOX_URL,
 *     token: string
 * }.
 */
export const REMOVE_MOBILE_CANDP_URL = 'REMOVE_MOBILE_CANDP_URL';


